import { useGetCatalogQuery } from '@platform/state/api';
import type { IWorkspaceCountProps } from './IWorkspaceCountProps';

/** Кількість модулів, установлених у робочому просторі (каталог простору) — клітинка таблиці «Робочі простори». */
export function WorkspaceModulesCount({ ws }: IWorkspaceCountProps) {
  const { data } = useGetCatalogQuery({ workspaceId: ws });
  return <span className="sp-mono">{data ? data.modules.filter((m) => m.installed).length : '…'}</span>;
}
